import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

/** Quando o contrato/privacidade muda, aluno e professor precisam aceitar a nova versão. */
export const TermsGate = () => {
  const { user, setUser, logout } = useAuth();
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!user?.terms_pending || user.onboarding_required || user.impersonator) return null;
  const accept = async () => {
    setBusy(true);
    try { setUser((await api.post("/me/accept-terms")).data); toast.success("Obrigado! Aceite registrado."); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="max-w-md [&>button]:hidden" onEscapeKeyDown={(e) => e.preventDefault()} onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="font-display">Atualizamos nossos termos</DialogTitle>
          <DialogDescription>Para continuar usando a plataforma, leia e aceite a versão atual.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-sm">
          <div className="flex gap-3">
            <a href="/termos" target="_blank" rel="noreferrer" className="text-[#1E9E2A] font-semibold hover:underline">Contrato e Termos de Uso</a>
            <a href="/privacidade" target="_blank" rel="noreferrer" className="text-[#1E9E2A] font-semibold hover:underline">Política de Privacidade</a>
          </div>
          <label className="flex items-start gap-2 cursor-pointer"><Checkbox checked={ok} onCheckedChange={(v) => setOk(!!v)} className="mt-0.5" data-testid="terms-gate-check" />Li e aceito o contrato/termos de uso e a política de privacidade.</label>
        </div>
        <div className="flex justify-between gap-2 pt-2">
          <Button variant="ghost" onClick={logout}>Sair</Button>
          <Button onClick={accept} disabled={!ok || busy} className="text-white" style={{ background: "#1E9E2A" }} data-testid="terms-gate-accept">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Aceitar e continuar"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
